export default "__VITE_PUBLIC_ASSET__4785dde4__"